import React, { useState, useEffect } from 'react';
import { useNavigate,useLocation } from 'react-router-dom'; 
import authService from '../services/authService'; 
import Logo from '../assets/std_emblem.png';


const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate(); 

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await authService.login(username, password);          
            navigate('/home'); 
        } catch (err) {
            setError('Invalid username or password');
        }
    };


    return (
    <div className="container">

        <div className="top-bar">
            <div className='logo-div'>
                <img src={Logo} alt="Standard Bank Logo"/>
            </div>
            <div>
                <h1 className='main-heading'>REGIONAL OUTLOOK | RESULTS</h1> 
            </div>
        </div>

        <div className="login">
          <h2>Sign In</h2>
          <form onSubmit={handleSubmit}>
            <div>
                {/* <label>Username:</label> */}
                <input
                    type="text"
                    value={username}
                    placeholder='Username'
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />
            </div>
            <div>
                {/* <label>Password:</label> */}
                <input
                    type="password"
                    value={password}
                    placeholder='Password'
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
            </div>
            <button type="submit">Login</button>
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </form>
        </div>

        <div>

        </div>
    </div>
  );

};

export default Login;
